// test1030
(1030 && 0);
